module.exports = __webpack_public_path__ + "static/e946fd09-5369-4035-b04a-db100dec1e17-original.b2fca183.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-materiana-tintagel/e946fd09-5369-4035-b04a-db100dec1e17-original.jpg
// module id = 1141
// module chunks = 168707334958949